// extracted by mini-css-extract-plugin
module.exports = {"authpage":"login_authpage__2DMf5","authcontainer":"login_authcontainer__2C97J","auth":"login_auth__3dKYB","logo":"login_logo__2-9ut"};